import PropTypes from 'prop-types';
import React from 'react';
import {get as _get} from 'lodash';

import Authorization from '@appComponents/Authorization';
import Chip from '@ui/Chip';
import Table from '@appComponents/Table';
import {getLink} from '@appComponents/Link';
import {IconEdit} from '@appComponents/IconCollection';
import * as RESOURCES from '@constants/resources';
import * as CONST from '@constants/variables';

import PropertyLicenceContentsRow, {contentRows} from './PropertyLicenceContentsRow';
import {
    columns,
    linkToPropertyLicenseEdit,
    renderCheckbox,
    renderLicensees,
    renderNameOfFirstLevelDependency,
    renderSportOrTopCategory,
} from '../utils/propertyLicenceTableHelper';

const authorizationObject = {
    [RESOURCES.PROPERTY_LICENCE]: CONST.SECURITY_PRIVILEGES_READ,
};

const PropertyLicenceTable = (props) => {
    const {loading} = props,
        propertyLicences = props.propertyLicences.map(el => ({
            ...el,
            contentSortValue: contentRows(el).map(content => content.text).join(','),
        }));

    const rowRenderer = (column, row) => {
        const officialName = _get(row, 'official_name', null),
            isTvStreaming = _get(row, 'is_tv_streaming', false);

        switch (column) {
            case 'id':
                return linkToPropertyLicenseEdit(row[column], row.id);
            case 'name':
                return (
                    <>
                        {linkToPropertyLicenseEdit(row[column], row.id)}
                        {isTvStreaming && <Chip size='small' label='TV Streaming' className='--marginLeft-0-5-em' />}
                        {officialName && <p className={'muted'}>{officialName}</p>}
                    </>
                );
            case 'sport' :
                return renderSportOrTopCategory(row);
            case 'licensees' :
                return renderLicensees(row);
            case 'licensor' :
            case 'content_tier' :
            case 'content_package_type' :
            case 'content_manager_user' :
            case 'property_licence_type' :
            case 'content_category' :
            case 'property_licence_status' :
                return renderNameOfFirstLevelDependency(row, column);
            case 'contents' :
                return PropertyLicenceContentsRow(row, row.id);
            case 'has_accreditation' :
                return renderCheckbox(row, column);
            case 'actions' :
                return (
                    <Authorization authorization={authorizationObject}>
                        <div className='actions-list-icon'>
                            <IconEdit
                                size='large'
                                link={getLink('propertyLicences.edit', {id: row.id})}
                                resource={RESOURCES.PROPERTY_LICENCE}
                            />
                        </div>
                    </Authorization>
                );
            default:
                return null;
        }
    };

    return (
        <div className='propertyLicences__table'>
            <Table
                noDataText='No property licences found'
                name='propertyLicencesList'
                columns={columns}
                data={propertyLicences}
                loading={loading}
                rowRenderer={rowRenderer}
            />
        </div>
    );
};

PropertyLicenceTable.defaultProps = {
    propertyLicences: [],
};

PropertyLicenceTable.propTypes = {
    propertyLicences: PropTypes.array,
    loading: PropTypes.bool,
};

export default PropertyLicenceTable;
